import { getCurrentCulture } from '@vp/culture-resolution';
import { getQueryParam } from './utils';

// eslint-disable-next-line import/prefer-default-export
export function getCurrentLocale() {
  return (getQueryParam('locale') || getCurrentCulture()).toLowerCase();
}
